import { TFilterSelected } from '@monorepo/types';
import { TFilterGroupModel, UiFilterModifiers } from '@monorepo/ui';
import { UTILS_GUARDS } from '../ui-filter.guards';

export const TICKET_LISTING_FILTER_MODEL = {
  createModel: (
    items: TFilterSelected[],
    prevModel?: TFilterGroupModel<TFilterSelected>,
    allowVirtualScroll = false,
    durationCustomLabelText?: string,
  ) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      if (UTILS_GUARDS.isTargetDateFilter(item)) {
        return {
          type: 'TARGET_DATE_FILTER',
          key: item.key,
          displayName: item.displayName,
          values: item.values,
          selectedValues: [],
          ...(item.version ? { version: item.version } : {}),
        };
      }
      if (UTILS_GUARDS.isMultiSelectFilter(item)) {
        return {
          type: 'MULTI_SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            ...val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(item.version ? { version: item.version } : {}),
        };
      }
      if (UTILS_GUARDS.isSelectFilter(item)) {
        return {
          type: 'SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            value: val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(allowVirtualScroll && item.values.length > 100
            ? {
                virtualScroll: {
                  itemSize: 40,
                  minBufferPx: window.screen.height / 2,
                  maxBufferPx: window.screen.height / 2,
                },
              }
            : {}),
        };
      }
      if (UTILS_GUARDS.isOrgFilter(item)) {
        return {
          type: 'ORG_HIERARCHY_FILTER',
          key: item.key,
          displayName: item.displayName,
          hierarchy: item,
          isDisabled: false,
          filteredOrgTree: {
            ...item,
            values: [],
          },
          ...(item.version ? { version: item.version } : {}),
        };
      }
      if (UTILS_GUARDS.isDurationFilter(item)) {
        return {
          type: 'DURATION_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            value: val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(durationCustomLabelText ? { customLabelText: durationCustomLabelText } : {}),
          ...(item.version ? { version: item.version } : {}),
        };
      }

      throw new Error('Type Not suppported');
    });
    const updatedFilterModel = prevModel
      ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel)
      : createNewFilterModel;
    return UiFilterModifiers.sortFilterItems(updatedFilterModel);
  },

  filterUpdateByGroup(
    filterGroupModel: TFilterGroupModel<TFilterSelected>,
    groupModeInfo: TFilterGroupModel<TFilterSelected>['groups'][number],
  ) {
    return UiFilterModifiers.filterUpdateByGroup(filterGroupModel, groupModeInfo);
  },
};
